import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GET_DOMAIN_CONFIGURATION } from "src/common/utils";
import { useMyDomainConfiguration } from "src/redux/hooks/hooks";
import { setDomainConfiguration } from "src/redux/reducers/domainConfiguration";

export const useDomainConfiguration = () => {
    // const domain = "qa.web.lewootrack.com" ?? window.location.hostname;
    // const domain = "qa.web.eneotransportation.com" ?? window.location.hostname;
    const domain = window.location.hostname;
    const dispatch = useDispatch();
    const { data, loading, error, refetch } = useQuery(GET_DOMAIN_CONFIGURATION, {
        variables: { domain },
    });
    const { config, } = useMyDomainConfiguration();
    useEffect(() => {
        dispatch(setDomainConfiguration({ config: data?.domainConfiguration ?? config, loading: false, error: null }));
    }, [data, domain]);
    return {
        config: data?.domainConfiguration,
        loading,
        error,
        refetch,
    };
};
